<Panel :header="title" style="min-width: 25em; height: 100%">
    <template #icons>
        <Button :disabled="errorLoading" size="small" @click="goToTopUpWallet">
            {{ isMobileWidth ? 'Opladen' : 'Saldo&nbsp;opladen' }}
            <aeg-icon icon="pi pi-plus-circle" />
        </Button>
    </template>
    <aeg-loader v-if="loading" />
    <aeg-error-loading v-else-if="errorLoading"
                       error-message="Er ging iets mis bij het ophalen van uw saldo."
                       @try-again="reload" />
    <div v-else class="flex flex-col items-center">
        <aeg-icon icon="pi pi-wallet" style="font-size: 2.5rem; padding-bottom: 1rem;" />
        <div class="heading-4">{{ formatCurrency(serviceWallet.walletAmount) }}</div>
    </div>
</Panel>

